import cookies from '../../services/cookies';

export const LOCALE = {
    EN: 'en',
    DE: 'de',
    NL: 'nl',
    LT: 'lt',
};

const defaultLocale = process.env.DEFAULT_LOCALE || cookies.get('locale') || navigator?.language?.split('-')[0];

export const DEFAULT_LOCALE = 
    Object.values(LOCALE).includes(defaultLocale)
    ? defaultLocale
    : LOCALE.EN;
